
import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { useAuth } from '@/context/AuthContext';
import { Subscription } from '@/types/subscription';
import { fetchUserSubscriptions } from '@/services/subscriptionFetchService';

export function useUserSubscriptions() {
  const { user } = useAuth();
  const [userSubscriptions, setUserSubscriptions] = useState<Subscription[]>([]);
  const [loadingSubscriptions, setLoadingSubscriptions] = useState(false);
  const [debugInfo, setDebugInfo] = useState<any>({});
  
  const fetchSubscriptions = async () => {
    if (!user) return;
    
    setLoadingSubscriptions(true);
    
    try {
      const { subscriptions, debugInfo: debug } = await fetchUserSubscriptions(user.email);
      setUserSubscriptions(subscriptions);
      setDebugInfo(debug);
      console.log("COMPLETE DEBUG INFO WITH BUSINESS DATA:", debug);
    } catch (error) {
      console.error("Failed to fetch user subscriptions:", error);
      toast.error("Failed to fetch subscription information");
      setDebugInfo({ error: error.message, userEmail: user.email });
    } finally {
      setLoadingSubscriptions(false);
    }
  };
  
  useEffect(() => {
    fetchSubscriptions();
  }, [user]);

  return {
    userSubscriptions,
    loadingSubscriptions,
    debugInfo,
    fetchUserSubscriptions: fetchSubscriptions
  };
}
